import { useEffect, useState } from 'react';
import { useRecoilState, useSetRecoilState } from 'recoil';
import { enableListDetailBanners } from '@Components/Utilities/SandhillsConstants';
import { approvalAmountLocalStorageName } from '@Components/Utilities/SandhillsConstants';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import atoms from '@Components/Utilities/SandhillsAtoms';
import translator from '@Components/Utilities/Translator';

const WizardBanner = (props) => {

    return (
        <a href={props.WizardURL} className={props.IsListPage ? 'wizard-banner list-page' : (props.IsHomePage ? 'wizard-banner home-page' : 'wizard-banner')}>
            <div className='banner-inner'>
                <div className='banner-text'>
                    <strong>{translator.translate("sandhills.tradesites.mvc.notsurewhatrvtobuy").toUpperCase()}</strong>
                    <p>{translator.translate("sandhills.tradesites.mvc.answerquestionsandwellhelpyoufindrv")}</p>
                </div>
                <div className='banner-logo'>
                    <img className='rv-logo' loading='eager' fetchPriority='high' decoding='async' src='/Content/RVUniverse/logo.svg' role="presentation"></img>
                </div>
                <div className='banner-button'>{translator.translate("sandhills.tradesites.mvc.findmyfirstrv")}</div>
            </div>
        </a>
    );
};

export default WizardBanner;